export const organizationTypes = [
  "Sole Proprietorship",
  "Private Limited Company (LTD)",
  "Public Limited Company (PLC)",
  "Limited by Guarantee",
  "Unlimited Comapany",
];

export const industries = [
  "Nigeria",
  "Automotive",
  "Consulting and Professional Services",
  "Consumer Goods",
  "Education",
  "Engineering and Construction",
  "Financial Services",
  "Government and Public Services",
  "Healthcare",
  "Hospitality, Recreation and Leisure",
  "Industrial Goods",
  "Information and Communications Technology",
  "Manufacturing",
  "Materials and Mining",
  "Media and Creative",
  "Non-Profit Organization",
  "Petro-chemicals, Oil and Gas",
  "Power and Utilities",
  "Real Estate",
  "Transportation",
  "Other",
];

export const specializations = [
  [
    "Agro-Allied Services",
    "Animal Production",
    "Crop Production",
    "Management",
    "Consulting and Support Services",
    "Other",
  ],
  [
    "Airplanes",
    "Cars",
    "Design",
    "Development",
    "Manufacturing",
    "Marketing and sales",
    "Motorbikes",
    "Trucks",
    "Other",
  ],
  [
    "Accounting",
    "Tax",
    "Audit and Finance",
    "Architectural",
    "Engineering and Related Services",
    "Auto-Repair Services",
    "Catering",
    "Commercial Printing",
    "Diversified Support Services",
    "Environmental and Facilities Services",
    "Health Consulting",
    "Human Resource and Employment Services",
    "IT Consulting",
    "Interior Decorations",
    "Investment and Advisory Services",
    "Language Services",
    "Legal Services",
    "Management",
    "Scientific and Technical Consulting Services",
    "Office Services and Supplies",
    "Personal and Home Care Services",
    "Recreation Services",
    "Rental Services",
    "Research and Development",
    "Security Services",
    "Specialized Design Services",
    "Survey and Valuation",
    "Transport services",
    "Tutoring Services",
    "Veterinary Services",
    "Waste and Disposal Services",
    "Other",
  ],
  [
    "Auto Parts and Equipment",
    "Automobiles",
    "Consumer Electronics",
    "Cosmetics",
    "Decorative Products",
    "Drinks",
    "Fashion/Apparel",
    "Food Products",
    "Furniture",
    "Non-durable Household Products",
    "Recreational Products",
    "Rubber and plastics",
    "Seafood and Meat",
    "Tires and Rubber",
    "Tobacco",
    "Toys and Games",
    "Other",
  ],
  [
    "Administrative and Secretarial Training",
    "Business and Management Training",
    "Colleges and Universities",
    "Educational Support Services",
    "Elementary and Secondary Schools",
    "Examination Preparation and Tutoring",
    "Fine Arts Schools",
    "Language Schools",
    "Sports and Recreation Instruction",
    "Technical Training",
    "Vocational Training",
    "Other",
  ],
  [
    "Aeronautical Engineering",
    "Agricultural Engineering",
    "Biochemical Engineering",
    "Building Construction",
    "Chemical Engineering",
    "Civil Engineering",
    "Computer Science Engineering",
    "Electrical and Instrumentation Engineering",
    "Electrical Engineering",
    "Electronics and Communication Engineering",
    "Highway, Street and Bridge Construction",
    "Industrial Construction",
    "Information Technology Engineering",
    "Management",
    "Consulting and Support Services",
    "Marine Engineering",
    "Mechanical Engineering",
    "Metallurgical Engineering",
    "Mining Engineering",
    "Other",
  ],
  [
    "Banking",
    "Capital Market",
    "Insurance",
    "Investment Banking and Brokerage",
    "Money Market",
    "PENSION Fund Administrators",
    "Thrifts and Mortgage Finance",
    "Wealth and Asset Management",
    "Other",
  ],
  [
    "Agriculture",
    "Education",
    "General Administration",
    "Healthcare",
    "International Development Agencies",
    " Ministries Departments and Agencies",
    "Monitoring, Evaluation and Compliance",
    "Public Finance and Accounting",
    "Public Officers",
    "Public-Private Partnership",
    "Public Utility Planning and Management",
    "Security, Defence and Public Safety",
    "Urban and Rural Development",
    "Welfare and Social Services",
    "Other",
  ],
  [
    "Ambulatory Healthcare Services",
    "Biotechnology",
    "Fitness, Wellness and Nutrition",
    "Health Maintenance Organization - HMO",
    "Healthcare Distributors",
    "Healthcare Equipment",
    "Healthcare Technology",
    "Hospitals and Clinics",
    "Laboratory and Diagnostics",
    "Life Sciences Tools and Services",
    "Pharmaceuticals",
    "Other",
  ],
  [
    "Procurement",
    "Inventory Management",
    "Transportation Management",
    "Warehousing and Distribution",
    "Supply Chain Analytics and Optimization",
    "e-Commerce Logistics",
    "Reverse Logistics",
    "Freight Forwarding",
    "Customs Brokerage",
    // "Travel and Tourism",
    // "Other",
  ],
  [
    "Aerospace and Defence",
    "Agricultural and Farm Machinery",
    "Commercial Vehicles and Trucks",
    "Containers and Packaging",
    "Electrical and Electronic Components and Equipment",
    "Industrial Machinery",
    "Trading Companies and Distributors",
    "Other",
  ],
  [
    "Application and Systems Software",
    "Cable and Satellite",
    "Communications Equipment",
    "Consulting and Other Services",
    "Data Hosting, Processing and Outsourced Services",
    "Electronic Equipment, Instruments and Components",
    "Internet Services and Infrastructure",
    "Technology Distributors",
    "Technology Hardware, Storage and Peripherals",
    "Telecommunication Services",
    "Other",
  ],
  [
    "Appliances and Electronic Products",
    "Automobiles and Parts",
    "Baby and Kids Products",
    "Beauty and Personal Care",
    "Building Materials",
    "Chemical",
    "Computers and Accessories",
    "Drugs and Pharmaceuticals",
    "Electrical Equipment, Appliances and Accessories",
    "Food and Beverages",
    "Garment and Fashion",
    "Health Products",
    "Home and Office Products",
    "Leather and Allied Products",
    "Machinery and Components",
    "Petro-chemical and Other Extractive Refining",
    "Phones, Tablets and Accessories",
    "Security Equipment, Appliances and Accessories",
    "Sports, Fitness and Wellness",
    "Textiles",
    "Tobacco",
    "Wood and Allied Products",
    "Other",
  ],
  [
    "Aluminium",
    "Coal Mining",
    "Construction Materials",
    "Diamonds and Gemstones Mining",
    "Forest Products",
    "General Mining",
    "Gold Mining",
    "Iron and Steel",
    "Metal and Glass Containers",
    "Paper Packaging",
    "Paper Products",
    "Platinum  Mining",
    "Precious Metals and Minerals",
    "Other",
  ],
  [
    "Advertising",
    "Cinematography",
    "Contents and Copywriting",
    "Digital Arts",
    "Distributors",
    "Event Planning",
    "Gaming",
    "Home Entertainment and Movies",
    "Music and Sound Recording",
    "PR and Branding",
    "Performing Arts",
    "Photography and Videography",
    "Printing and Publishing",
    "Radio and Television Broadcasting",
    "Social Media",
    "Theatre and Arts",
    "Other",
  ],
  [
    "Charities/Foundations",
    "Civil Rights and Advocacy Organizations",
    "Fund Agencies",
    "Labour Unions",
    "Political Parties",
    "Religious Organizations",
    "Socio-Cultural Organizations",
    "Other",
  ],
  [
    "Alternative Fuels",
    "Commodity Chemicals",
    "Diversified Chemicals",
    "Exploration and Production",
    "Fertilizers and Agricultural Chemicals",
    "Industrial Gases",
    "Integrated Oil and Gas",
    "Equipment and Services",
    "Specialty Chemicals",
    "Other",
  ],
  [
    "Electrical Power Distribution",
    "Electrical Power Generation",
    "Electrical Power Transmission",
    "Equipment",
    "Gas Distribution",
    "Gas Generation",
    "Gas Transmission",
    "Green Energy",
    "Sewage Utilities",
    "Water Treatment and Distribution",
    "Water Utilities",
    "Other",
  ],
  [
    "Commercial",
    "Industrial",
    "Land",
    "Real Estate Construction",
    "Residential",
    "Other",
  ],
  [
    "Air Freight and Logistics",
    "Airlines",
    "Airport Services",
    "Highways Services",
    "Marine",
    "Marine Ports and Services",
    "Postal & Delivery Services",
    "Rail",
    "Railtrack Services",
    "Rental Services",
    "Road",
    "Trucking",
    "Other",
  ],
  ["Other"],
];
